import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User invited to a library',
  name: 'invited_library_member',
  params: [
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The email of the invited library member',
      name: 'library_member_email',
      required: true,
      type: 'string',
    },
    {
      description: 'The role of the invited library member',
      name: 'library_member_role_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
